import { Injectable } from "@angular/core";
import { UserManagementService } from "../../../shared/core-jpats/services/user-management.service";
import { RoleConstants } from "../core/role.constants";
import { NdmsAuthService } from "../../../../../../ndms/app/shared/core-ndms/services/ndms-auth.service";
import { AuthApiService } from "../../../shared/core-jpats/services/auth.service";

import { RmsUserManagementService } from "projects/rms/app/shared/core-rms/rms-user-management.service";
import { RmsPolicyPermissionsService } from 'projects/rms/app/shared/core-rms/rms-policy-permissions.service';

@Injectable()
export class AccessService {
  currentUser: any;

  private _blocked = false;
  private _failures = 0;

  jpatsPermissions = [
    "Jpats:Patient:Authentication:Access",
    "Jpats:Patient:Authentication:Save",
    "Jpats:Patient:FCC:Access",
    "Jpats:Patient:FCC:Save",
    "Jpats:Patient:Location:Access",
    "Jpats:Patient:Location:Save",
    "Jpats:Patient:Manifest:Access",
    "Jpats:Patient:Manifest:Save",
    "Jpats:Patient:Operation:Access",
    "Jpats:Patient:Operation:Save",
    "Jpats:Patient:Patients:Access",
    "Jpats:Patient:Patients:Save",
    "Jpats:Report:Dashboard:Access",
    "Jpats:Report:Dashboard:Save",
    "Jpats:Report:Location:Access",
    "Jpats:Report:Location:Save",
    "Jpats:Report:Patients:Access",
    "Jpats:Report:Patients:Save",
    "Jpats:User:Access",
    "Jpats:User:Save",
    "Jpats:Admin:Access",
    "Jpats:Admin:Save"
  ];

  adminRoles: string[] = [
    this.roleConstants.MODIFY_CATEGORIES,
    this.roleConstants.MODIFY_FCCS,
    this.roleConstants.MODIFY_USER_ACCOUNT,
    this.roleConstants.VIEW_USER_ACCOUNTS];

  constructor(private authService: AuthApiService,
    private userManagementService: UserManagementService,
    private rmsUserManagementService: RmsUserManagementService,
    public policyPermissionsService: RmsPolicyPermissionsService,
    private roleConstants: RoleConstants) {
    policyPermissionsService.loadEffectivePermissions(this.jpatsPermissions);
    this.rmsUserManagementService.getCurrentCachedUser().subscribe(currentUser => {
      this.currentUser = currentUser;
    });
  }

  hasPermission(permission: string) {
    if (!this._blocked) {
      if ((!this.currentUser || (this.currentUser && this.currentUser.key === null)) && this._failures < 5) {
        this._blocked = true;
        this._failures++;
        this.rmsUserManagementService.getCurrentCachedUser().subscribe(currentUser => {
          this.currentUser = currentUser;
          this._blocked = false;
        });
      }
    }
    return this.policyPermissionsService.hasPermission(permission);
  }
}
